<router-outlet></router-outlet>

<p-toast></p-toast>

<ngx-spinner type="square-jelly-box"></ngx-spinner>
